export enum FileType {
    BOOKEXTRACT = 'bookextract',
    FILECOVER = 'filecover'
}